import type { ReactNode } from "react";
import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";
import CircularProgress from "@mui/material/CircularProgress";

type TableProps = {
  children: ReactNode;
  isLoading?: boolean;
};

function TableRoot({ children, isLoading }: TableProps) {
  return (
    <TableContainer>
      {isLoading ? (
        <div className="flex justify-center items-center h-64">
          <CircularProgress size={60} className="text-primary" />
        </div>
      ) : (
        <Table className="min-w-2xl" aria-label="customized table">
          {children}
        </Table>
      )}
    </TableContainer>
  );
}

export default TableRoot;
